import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { Grid, Box, Typography } from '@material-ui/core';
import { FormTextInput, FormContainer, Button } from '../../_common';

import { useFormUpdate, useVhListener } from '../../../hooks';
import { Context as AuthContext } from '../../../context/AuthContext';

import Logo from '../../../assets/logo_jamii_2.svg';
import useStyles from './styles';
import useSchemas from './form.schema';

const PasswordRecoveryForm = ({ history }) => {
  const [{ vhUpdated }] = useVhListener();
  const {
    lRoot,
    lFormWrapper,
    logoClass,
    submitWrapper,
    link,
    formHelper,
  } = useStyles({
    vhUpdated,
  });
  const { initialState, validationStateSchema } = useSchemas();

  const {
    state: { errorMessage },
    sendRecoveryToken,
    resetValues,
  } = useContext(AuthContext);

  useEffect(() => {
    resetValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [
    updatedData,
    handleUpdateData,
    buttonState,
    handleOnSubmit,
    isButtonLoading,
  ] = useFormUpdate(initialState, validationStateSchema, (cleanData) =>
    handleSubmit(cleanData)
  );

  const handleSubmit = async (cleanData) => {
    try {
      await sendRecoveryToken(cleanData);
      history.push('/login');
    } catch {
      throw Error('Error sends to previous error block.');
    }
  };

  return (
    <Grid container item className={lRoot} wrap="nowrap">
      <img src={Logo} alt="jamii-logo" className={logoClass} />
      <Grid item className={lFormWrapper}>
        <FormContainer errorMessage={errorMessage}>
          <FormTextInput
            required
            name="email"
            placeholder="correo"
            value={updatedData.email.value}
            errorValue={updatedData.email.error}
            onChange={handleUpdateData}
            type="email"
          />
          <Box className={submitWrapper}>
            <Button
              handleClick={handleOnSubmit}
              disabled={!buttonState}
              isLoading={isButtonLoading}
            >
              Recuperar contraseña
            </Button>
          </Box>
          <Box width="100%" textAlign="center">
            <Typography
              variant="body2"
              component="p"
              gutterBottom
              className={formHelper}
            >
              Ingresa el correo con el que inicias sesión, te enviaremos un
              token a este mail que te servirá para reiniciar tu contraseña, el
              correo puede tardar hasta 10 minutos.
            </Typography>
          </Box>
        </FormContainer>
        <Box width="100%" textAlign="center">
          <Typography
            className={link}
            style={{ fontSize: 12 }}
            onClick={() => history.push('/login')}
          >
            Atrás
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default withRouter(PasswordRecoveryForm);
